import { extendTheme, ThemeConfig } from '@chakra-ui/react';
import { StepsStyleConfig as Steps } from 'chakra-ui-steps';

export const theme = extendTheme(
  {
    colors: {
      onsupply: {
        50: '#69A9D3',
        100: '#5AA0CF',
        200: '#4A97CA',
        300: '#388DC5',
        400: '#2482BF',
        500: '#0E76B9',
        600: '#0D6BA8',
        700: '#0C6199',
        800: '#0B588B',
        900: '#0A507E',
      },
      activeblue: {
        100: '#007AFF',
        200: '#007AFF',
        300: '#007AFF',
        400: '#007AFF',
        500: '#007AFF',
        600: '#007AFF',
        700: '#007AFF',
        800: '#007AFF',
        900: '#007AFF',
      },
    },
    components: {
      Steps,
    },
    fonts: {
      heading: 'Roboto',
      body: 'Roboto',
    },
    styles: {
      global: {
        body: {
          bg: 'white',
          color: 'gray.700',
        },
      },
    },
  },
  {
    initialColorMode: 'light',
    useSystemColorMode: true,
  } as ThemeConfig,
);
